// extracted by mini-css-extract-plugin
export default {"wrapper":"ChatData_wrapper__Jerya","left":"ChatData_left__8Oxzr","center":"ChatData_center__bhTeo","right":"ChatData_right__Q+cVt"};